<div #moreRef class="cell-list-more-box">
  <myre-tag
    class="cell-list-more_tag"
    [type]="TagTypeEnum.Tertiary"
    [withBackground]="false"
    (click)="onMoreClick()"
  >
    {{ eventCalendarDay.leftEventsNumber }}
    {{ '_library.calendar.more' | translate }}
  </myre-tag>

  @if (isOpen) {
    <myre-tooltip
      [ref]="moreRef"
      [disableTrimContent]="true"
      openOn="click"
      closeOn="click"
    >
      <div class="cell-list-more" #morePopup>
        <!-- TODO Attach onClose click -->
        <!-- <span (click)="onMoreCloseClick()"
      class="cell-list-more-close myre-icon-close"></span> -->
        <div class="cell-list-more-title">
          {{ eventCalendarDay.dayWithMonth }}
        </div>
        <div class="cell-list-more-list">
          @for (
            event of eventCalendarDay.events;
            track trackByFnc($index, event)
          ) {
            <myre-event-calendar-event
              [event]="event"
              (onEventUpdated)="onEventUpdatedEmit($event)"
            />
          }
        </div>
        @if (canEdit) {
          <myre-action-button
            (onClick)="onEventCreatedClick(eventCalendarDay.rawValue)"
            color="green"
            type="primary"
            label="{{ '_library.calendar.createAnEvent' | translate }}"
          />
        }
      </div>
    </myre-tooltip>
  }
</div>
